/**
 * What a balance payment can actually draw on.
 *
 * One function because three screens ask the same question (the shared order flow, the VM
 * wizard's funding card and the storage wizard) and the answer has to match
 * `PayOrderWithBalanceCommandHandler`, which re-checks it server-side before moving money.
 */

import type { Balance } from "@/types/billing";

/**
 * The spendable total in major units, or null when the balance has not loaded.
 *
 * `totalBalance` is the server's own answer and is what should be used; the fallback covers an
 * API response predating that field. Both are CASH. `bonusCreditBalance` is deliberately NOT
 * added: it is the budget for a sign-up-bonus trial, and counting it here showed a tenant whose
 * only funds were a 100,000 sign-up bonus a 100,000 payable balance, then offered them a real
 * purchase from it.
 */
export function getPayableBalance(balance: Balance | null | undefined): number | null {
  if (!balance) {
    return null;
  }

  return balance.totalBalance ?? balance.availableBalance;
}
